import React, { createContext, useContext } from "react";
import { rolePermissions } from "./RolePermission";
 
const RBACContext = createContext();
 
export const RBACProvider = ({ role, children }) => {
  // Normalize role to ensure it matches RolePermission keys
  const normalizedRole = (role || "").replace(/\s+/g, '');
  const permissions = rolePermissions[normalizedRole] || { sidebar: [], actions: false };
 
  console.log('[LOG] RBACProvider - Role:', normalizedRole, 'Permissions:', permissions);
 
  return (
    <RBACContext.Provider value={{ role: normalizedRole, permissions }}>
      {children}
    </RBACContext.Provider>
  );
};
 
 
export const useRBAC = () => useContext(RBACContext);